import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import styles from './LoginUser.module.scss';
import UserPop from '../UserPop';
import Clickable from '../Clickable';
import User from './User';
import ConnectWallet from './ConnectWallet/index';
import { useGlobalState } from '../../store';
import DApp from '../../utils/DApp';
import Cyano from '../../utils/DApp/Cyano';
import Onto from '../../utils/DApp/Onto';

const LoginUser: React.FC = () => {
  const { t } = useTranslation();
  const [connectShowing, setConnectShowing] = useState<boolean>(false);
  const [dApp, setDApp] = useGlobalState('dApp');
  const setAddressList = useGlobalState('addressList')[1];
  const setScoreLoading = useGlobalState('scoreLoading')[1];

  /**
   * load local dApp data when exist.
   */
  const tryGetLocaleStatus = () => {
    const localType = DApp.getCacheLoginType();
    if (localType) {
      const DAppBuild = localType === 'Cyano' ? Cyano : Onto;
      const dAppResult = DAppBuild.tryGetLocaleDApp();
      if (dAppResult) {
        setDApp(dAppResult);
        setAddressList(dAppResult.addressList);
        if (dAppResult.score.length === 0) {
          setScoreLoading(true);
          dAppResult.fetchScore().finally(() => {
            setScoreLoading(false);
          });
        }
        if (localType === 'Cyano') {
          Cyano.getOntIdWithCyano(); // connect cyano
        }
      }
    } else {
      setConnectShowing(true); // auto show sign dialog.
    }
  };

  const loginSuccessHandler = (resultOnt: string) => {
    setConnectShowing(false);
  };

  const quit = () => {
    if (dApp) {
      dApp.clearCache();
      setDApp(null);
      setAddressList([]);
    }
  };

  useEffect(() => {
    tryGetLocaleStatus();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.loginUser}>
      {
        dApp ? (
          <div className={styles.userWrapper}>
            <User ont={dApp.ontId} />
            <div className={styles.popWrapper}>
              <UserPop ontId={dApp.ontId} onOut={quit} />
            </div>
          </div>
        ) : (
          <Clickable event={() => setConnectShowing(true)} label={t('login')}>
            <div className={styles.sign}>{t('login')}</div>
          </Clickable>
        )
      }
      <Modal
        title={t('connect_to_wallet')}
        visible={connectShowing}
        onCancel={() => setConnectShowing(false)}
        footer={null}
        width={450}
        destroyOnClose
      >
        <ConnectWallet onLoginSuccess={loginSuccessHandler} />
      </Modal>
    </div>
  );
};

export default LoginUser;
